// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAppClientInfoDto
 */
export interface IAppClientInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IAppClientInfoDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IAppClientInfoDto
     */
    description?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IAppClientInfoDto
     */
    organization_ids: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof IAppClientInfoDto
     */
    client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IAppClientInfoDto
     */
    secret?: string;
}

/**
 * Check if a given object implements the IAppClientInfoDto interface.
 */
export function instanceOfIAppClientInfoDto(value: object): value is IAppClientInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organization_ids' in value) || value['organization_ids'] === undefined) return false;
    return true;
}

export function IAppClientInfoDtoFromJSON(json: any): IAppClientInfoDto {
    return IAppClientInfoDtoFromJSONTyped(json, false);
}

export function IAppClientInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAppClientInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'organization_ids': json['organization_ids'],
        'client_id': json['client_id'] == null ? undefined : json['client_id'],
        'secret': json['secret'] == null ? undefined : json['secret'],
    };
}

export function IAppClientInfoDtoToJSON(json: any): IAppClientInfoDto {
    return IAppClientInfoDtoToJSONTyped(json, false);
}

export function IAppClientInfoDtoToJSONTyped(value?: IAppClientInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'organization_ids': value['organization_ids'],
        'client_id': value['client_id'],
        'secret': value['secret'],
    };
}

